/* TrueSanity bag (cart v2), Oct 2026.
   One engine for the bag drawer (snippets/ts-cart-drawer.liquid) and the bag page (sections/ts-cart-page.liquid).
   Data: the JSON from snippets/ts-cart-json.liquid, refetched with /?sections=ts-cart-data after every change.
   Changes go through Shopify's Cart API (/cart/add.js, /cart/change.js, /cart/update.js).

   What a shopper can do in the bag:
   - change any product option (metal, size, carat weight, earring back, chain length...) = the variant is swapped
   - change the ring size of a design-your-own ring (a line note, from the sizes the setting allows)
   - upgrade the stone quality (sibling product, same group: natural stays natural, lab stays lab)
   - change quantity (catalog pieces only), remove, save to the wishlist
   - choose the free gift of the tier they earned (assets/ts2-gift.js keeps the gift line right)
   - gift note + hide prices, promo code
   Checks: every design-your-own diamond is still for sale (same rule as assets/ts2-cart-check.js), matched earring
   pairs are complete, and prices that moved since the piece was added are pointed out. Checkout runs the checks first.
   No jQuery. Nothing here changes products, only the bag. */
(function () {
  'use strict';
  if (window.TSCart) return;
  var d = document, w = window;
  var ROOT = (w.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var RATE = (w.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;
  var DAPI = w.API_URL || 'https://truesanity.011101100110111001110011.net/api/';
  var NAT_API = w.TS_NATURAL_API || 'https://tghmqkncwbxynkulevgw.supabase.co/functions/v1/vdb-diamonds';   // natural: VDB feed in Supabase
  var DKEY = 'TSANITY121A3VG7NEMVRXXEWGM';
  var LS_PRICES = 'tsc_prices_v1';

  var S = {
    data: null, busy: false, error: '', openMake: {}, editing: {}, sold: {}, soldIds: {}, broken: [], checked: false,
    dcost: {}, priceMoves: {}, promoOpen: false, promoMsg: '', giftNoteOpen: null, heldElse: {}, holdUntil: {}, working: null
  };

  /* ---------- helpers ---------- */
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cur() { return (S.data && S.data.currency) || 'USD'; }
  function money(c) {
    c = Math.round(c || 0);
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur(), minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(c / 100);
    } catch (e) { return '$' + (c / 100).toLocaleString('en-US'); }
  }
  function moneyRound(c) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur(), maximumFractionDigits: 0 }).format(Math.round((c || 0) / 100)); }
    catch (e) { return '$' + Math.round((c || 0) / 100).toLocaleString('en-US'); }
  }
  function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase(); }
  function ct(x) { var n = parseFloat(x); return isNaN(n) ? '' : (Math.round(n * 100) / 100).toFixed(2); }
  function json(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var e = new Error((j && (j.description || j.message)) || 'Something went wrong. Please try again.'); e.status = r.status; throw e; }
        return j;
      });
    });
  }
  function post(path, body) {
    return json(ROOT + 'cart/' + path + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), __tsc: true });
  }
  function wizard(item) {
    var p = item.properties || {}, x = null;
    if (!p._wizardInfo) return null;
    try { x = JSON.parse(JSON.parse(p._wizardInfo)); } catch (e) { try { x = JSON.parse(p._wizardInfo); } catch (e2) {} }
    return x && typeof x === 'object' ? x : null;
  }
  function parseData(html) {
    var m = String(html || '').match(/<script[^>]*data-ts-cart-json[^>]*>([\s\S]*?)<\/script>/);
    if (!m) throw new Error('bag data');
    return JSON.parse(m[1]);
  }
  function giftCfg() {
    var el = $('[data-ts2-gift-config]'); if (!el) return null;
    try { var c = JSON.parse(el.textContent); c.tiers = (c.tiers || []).slice().sort(function (a, b) { return a.min - b.min; }); return c; } catch (e) { return null; }
  }

  /* ---------- pieces: what the shopper sees as one item ----------
     add-on lines ride on their piece: engraving (shared _rendom_no), a ring's gemstone line (_ring_product_id),
     and the two diamonds of a matched earring pair (shared _earring_bundle). Gift lines are shown in the gift block. */
  function pieces() {
    var items = (S.data && S.data.items) || [], used = {}, out = [];
    function attached(it) {
      var p = it.properties || {};
      return it.addon || p._engrave === true || p._engrave === 'true' || p._gemstone_with_ring === 'true' || /^diamond/.test(p._earring_part || '');
    }
    items.forEach(function (it) {
      if (it.gift || attached(it)) return;
      var p = it.properties || {}, parts = [it];
      used[it.key] = 1;
      items.forEach(function (o) {
        if (used[o.key] || o.gift || o === it) return;
        var q = o.properties || {};
        var hit = (p._rendom_no && q._rendom_no && String(p._rendom_no) === String(q._rendom_no) && attached(o)) ||
          (q._gemstone_with_ring === 'true' && String(q._ring_product_id) === String(it.product_id)) ||
          (p._earring_bundle && q._earring_bundle === p._earring_bundle);
        if (hit) { parts.push(o); used[o.key] = 1; }
      });
      out.push(mkPiece(it, parts));
    });
    // anything left over (an engraving whose piece was removed elsewhere) still shows, so it can be removed
    items.forEach(function (it) { if (!used[it.key] && !it.gift) { used[it.key] = 1; out.push(mkPiece(it, [it])); } });
    return out;
  }
  function mkPiece(main, parts) {
    var pc = { main: main, parts: parts, keys: parts.map(function (x) { return x.key; }), key: main.key };
    pc.price = parts.reduce(function (a, x) { return a + x.line_price; }, 0);
    pc.original = parts.reduce(function (a, x) { return a + x.original_line_price; }, 0);
    pc.w = wizard(main);
    pc.bundle = (main.properties || {})._earring_bundle || '';
    pc.engraving = parts.filter(function (x) { var p = x.properties || {}; return p._engrave === true || p._engrave === 'true' || /engrav/i.test(x.type || ''); })[0] || null;
    return pc;
  }
  function visibleCount() { return pieces().reduce(function (a, pc) { return a + pc.main.quantity; }, 0); }

  /* ---------- what we make (same rules as the product page and the ring builder) ---------- */
  var NICE = { material: 'Material', accent: 'Diamonds & gemstones', labor: 'Craftsmanship', chain: 'Chain', backing: 'Backing', logistic: 'Logistics & security' };
  function makeOf(pc) {
    var it = pc.main, priceShop = Math.round(it.price / RATE);
    if (pc.w) {
      var x = pc.w;
      var setting = Math.round(((parseFloat(x.setting_material_cost) || 0) + (parseFloat(x.setting_labor_cost) || 0) + (parseFloat(x.setting_logistic_cost) || 0)) * 100);
      var ids = [x.stone_id, x.stone_id1].filter(Boolean), dc = 0, ok = setting > 0 && ids.length > 0;
      ids.forEach(function (id) { if (S.dcost[id] == null) ok = false; else dc += S.dcost[id]; });
      if (pc.bundle) {   // own earring pair: setting line + two diamond lines, prices summed
        priceShop = Math.round(pc.price / RATE / it.quantity);
      }
      if (!ok) return null;
      var lines = [
        { label: 'Setting: gold and side stones', cents: Math.round((parseFloat(x.setting_material_cost) || 0) * 100) },
        { label: ids.length > 1 ? 'Center diamonds' : 'Center diamond', cents: dc },
        { label: 'Craftsmanship', cents: Math.round((parseFloat(x.setting_labor_cost) || 0) * 100) },
        { label: 'Logistics', cents: Math.round((parseFloat(x.setting_logistic_cost) || 0) * 100) }
      ].filter(function (l) { return l.cents > 0; });
      var cost = lines.reduce(function (a, l) { return a + l.cents; }, 0), diff = priceShop - cost;
      return { lines: lines, diff: diff, pct: Math.round(diff * 100 / priceShop), short: Math.round(diff * 100 / priceShop) + '%' };
    }
    // full = list price (decides which cost view applies); paid = what this shopper actually pays after
    // Shopify's discounts, so "We make" drops with the 9% / 11% promo.
    var c = it.cost || {}, full = Math.round(it.variant_price / RATE) || priceShop, unit = priceShop || full;
    if (full >= 50000) {
      var ls = ['material', 'accent', 'labor', 'chain', 'backing', 'logistic'].filter(function (k) { return c[k] > 0; })
        .map(function (k) { return { label: NICE[k], cents: c[k] }; });
      var tot = ls.reduce(function (a, l) { return a + l.cents; }, 0);
      if (!tot) return null;
      var df = unit - tot;
      return { lines: ls, diff: df, pct: Math.round(df * 100 / unit), short: Math.round(df * 100 / unit) + '%' };
    }
    if (c.prodlog > 0) {
      var d2 = unit - c.prodlog, p2 = Math.round(((d2 / 100) - 50) * 100 / (unit / 100));
      return { lines: [{ label: 'Production & logistics', cents: c.prodlog }], diff: d2, pct: Math.round(d2 * 100 / unit), short: '$50 + ' + p2 + '%' };
    }
    return null;
  }
  function giftLine() { return ((S.data && S.data.items) || []).filter(function (i) { return i.gift; })[0] || null; }
  function giftCost(g) {
    var cfg = giftCfg(); if (!g || !cfg) return 0;
    var c = 0;
    cfg.tiers.forEach(function (t) { t.gifts.forEach(function (x) { x.variants.forEach(function (v) { if (String(v.id) === String(g.variant_id)) c = v.cost || 0; }); }); });
    return c;
  }
  function bagMake(list) {
    var total = 0, ok = list.length > 0;
    list.forEach(function (pc) { var m = makeOf(pc); if (!m) ok = false; else total += m.diff * pc.main.quantity; });
    if (!ok) return null;
    return total - giftCost(giftLine());
  }

  /* ---------- diamonds: still for sale? (shared feed: a stone can sell while it sits in a bag) ---------- */
  var dcache = {}, FORCE = false;
  function diamondRec(id, kind) {
    var ck = kind + ':' + id, hit = dcache[ck];
    if (!FORCE && hit && Date.now() - hit.t < 60000) return hit.p;
    var p = diamondFetch(id, kind); dcache[ck] = { t: Date.now(), p: p }; return p;
  }
  function diamondFetch(id, kind) {
    // natural and lab single diamonds: VDB in Supabase (old lab ids are passed through to the old service there)
    var url = kind === 'pair' ? DAPI + 'diamonds/apiservices/dyoe/new_api/' + id : NAT_API + '/' + id + (kind === 'natural' ? '' : '?kind=lab');
    return fetch(url, { headers: { Accept: 'application/json', 'X-API-Key': DKEY } })
      .then(function (r) { if (r.status === 404) return { gone: true }; if (!r.ok) return { unknown: true }; return r.json().then(function (j) { return { rec: j }; }); })
      .catch(function () { return { unknown: true }; });   // our service down: never block a sale on our own outage
  }
  function costOf(x) {
    return Math.round((parseFloat(x.rapent_price) || (parseFloat(x.Price_Per_Carat) * parseFloat(x.Weight || x.weight || x.size)) || 0) * 100);
  }
  function checkStones() {
    var list = pieces().filter(function (pc) { return pc.w && pc.w.stone_id; });
    var jobs = [];
    list.forEach(function (pc) {
      var p = pc.main.properties || {}, x = pc.w;
      var natural = /natural/i.test(p._diamond_type_new || '');
      var own = !!p._pair_own, earring = !!p._earring_product;
      var ids = own && x.stone_id1 ? [x.stone_id, x.stone_id1] : [x.stone_id];
      var kind = earring && !own ? 'pair' : natural ? 'natural' : 'lab';
      jobs.push(Promise.all(ids.map(function (id) { return diamondRec(id, kind); })).then(function (rs) {
        var gone = rs.some(function (r) {
          if (r.gone) return true;
          if (r.unknown) return false;
          var j = r.rec || {};
          return !(j.Diamond_ID || j.diamond_id || j.Diamond_ID2 || j.diamond_id2);
        });
        if (gone) S.sold[pc.key] = true; else delete S.sold[pc.key];
        if (kind !== 'pair') rs.forEach(function (r, i) { if (r.rec) { var c = costOf(r.rec); if (c > 0) S.dcost[ids[i]] = c; } });
      }));
    });
    // matched earring pairs: setting + diamond 1 + diamond 2, same quantity
    var by = {};
    ((S.data && S.data.items) || []).forEach(function (it) { var b = it.properties && it.properties._earring_bundle; if (b) (by[b] = by[b] || []).push(it); });
    S.broken = Object.keys(by).filter(function (b) {
      var ls = by[b], parts = ls.map(function (it) { return it.properties._earring_part; }).sort().join();
      return parts !== 'diamond1,diamond2,setting' || ls.some(function (it) { return it.quantity !== ls[0].quantity; });
    }).map(function (b) { return by[b].map(function (it) { return it.key; }); });
    return Promise.all(jobs).then(function () {
      S.checked = true;
      Object.keys(S.sold).forEach(function (k) { if (!list.some(function (pc) { return pc.key === k; })) delete S.sold[k]; });
      [S.heldElse, S.holdUntil].forEach(function (m) { Object.keys(m).forEach(function (k) { if (!list.some(function (pc) { return pc.key === k; })) delete m[k]; }); });
      return holdStones(list);
    }).then(function () {
      tickHolds();
      return Object.keys(S.sold).length === 0 && S.broken.length === 0 && Object.keys(S.heldElse).length === 0;
    });
  }
  // send a sold stone's setting back to the builder; the new ring replaces this bag line (assets/ts2-builder.js)
  function swapDiamond(pc) {
    var x = pc.w, p = pc.main.properties || {}, st = {};
    var pendant = !!p._necklace_product, earring = !!p._earring_product;
    var stKey = pendant ? 'ts2_pendant' : earring ? 'ts2_earring' : 'ts2_ring';
    var shape = x.stone_shape || p._stoneShape, carat = parseFloat(x.stone_carat || p._stoneCarat) || 1;
    try { st = JSON.parse(localStorage.getItem(stKey) || '{}') || {}; } catch (e) {}
    if (!st.setting || st.setting.handle !== x.setting_product_handle) {
      st.setting = { handle: x.setting_product_handle, pid: x.setting_product_id, vid: x.setting_variant_id, sku: x.setting_variant_sku,
        metal: x.setting_selected_metal, price: Math.round(parseFloat(x.setting_variant_price) || 0), design: String(x.setting_product_name || '').split(' - ').pop(),
        title: x.setting_product_name, shape: shape, shapes: x.setting_allowed_shapes, minCt: parseFloat(x.setting_min_carat_size) || 0.3, maxCt: parseFloat(x.setting_max_carat_size) || 4,
        image: x.setting_image_url, link: '/products/' + x.setting_product_handle + '?variant=' + x.setting_variant_id };
    }
    delete st.diamond;
    try { localStorage.setItem(stKey, JSON.stringify(st)); sessionStorage.setItem('ts2ReplaceLine', pc.key); sessionStorage.setItem('ts2ReplaceVariant', String(pc.main.variant_id)); } catch (e) {}
    location.href = (pendant ? '/pages/build-your-necklace' : earring ? '/pages/build-your-earrings' : '/pages/build-your-ring') +
      '?step=diamond&shape=' + encodeURIComponent(shape) + '&ct=' + carat + (/natural/i.test(p._diamond_type_new || '') ? '&dt=natural' : '');
  }

  /* ---------- holds: a DYOR diamond in this bag is reserved for this shopper for 30 minutes (Supabase "holds").
     Renewed whenever the bag is looked at or checkout is pressed. Fails open: our outage never blocks a sale. ---------- */
  var HOLDS = w.TS_HOLDS_URL || 'https://tghmqkncwbxynkulevgw.supabase.co/functions/v1/holds';
  var SHARE = w.TS_SHARE_URL || 'https://tghmqkncwbxynkulevgw.supabase.co/functions/v1/bag-share';
  function holderId() {
    var h = null; try { h = localStorage.getItem('tsc_holder'); } catch (e) {}
    if (!h) { h = 'h-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12); try { localStorage.setItem('tsc_holder', h); } catch (e) {} }
    return h;
  }
  function holdsCall(body) {
    body.holder = holderId();
    return fetch(HOLDS, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); }).catch(function () { return null; });
  }
  function stoneIds(pc) {
    var x = pc.w, p = pc.main.properties || {}; if (!x || !x.stone_id) return [];
    return p._pair_own && x.stone_id1 ? [String(x.stone_id), String(x.stone_id1)] : [String(x.stone_id)];
  }
  function holdStones(list) {
    var byKind = {};
    list.forEach(function (pc) {
      if (S.sold[pc.key]) return;
      var p = pc.main.properties || {}, kind = p._earring_product && !p._pair_own ? 'pair' : /natural/i.test(p._diamond_type_new || '') ? 'natural' : 'lab';
      (byKind[kind] = byKind[kind] || []).push(pc);
    });
    return Promise.all(Object.keys(byKind).map(function (kind) {
      var pcs = byKind[kind], ids = [].concat.apply([], pcs.map(stoneIds));
      return holdsCall({ op: 'hold', kind: kind, ids: ids }).then(function (j) {
        if (!j) return;   // service down: treat as fine
        pcs.forEach(function (pc) {
          var mine = stoneIds(pc), blocked = mine.some(function (id) { return (j.blocked || []).indexOf(id) > -1; });
          if (blocked) { S.heldElse[pc.key] = true; delete S.holdUntil[pc.key]; }
          else { delete S.heldElse[pc.key]; var t = mine.map(function (id) { return j.held && j.held[id] ? Date.parse(j.held[id]) : 0; }).filter(Boolean); if (t.length) S.holdUntil[pc.key] = Math.min.apply(null, t); }
        });
      });
    }));
  }
  function releaseStones(pcs) {
    var ids = [].concat.apply([], (pcs || []).map(stoneIds)); if (ids.length) holdsCall({ op: 'release', ids: ids });
  }
  var holdTimer = null;
  function tickHolds() {
    clearInterval(holdTimer);
    if (!Object.keys(S.holdUntil).length) return;
    holdTimer = setInterval(function () {
      $$('[data-tsc-hold]').forEach(function (el) {
        var until = S.holdUntil[el.getAttribute('data-tsc-hold')], left = Math.min(1800, Math.max(0, Math.round(((until || 0) - Date.now()) / 1000)));
        el.textContent = left ? Math.floor(left / 60) + ':' + ('0' + (left % 60)).slice(-2) : '0:00';
      });
    }, 1000);
  }

  /* ---------- prices that moved since the piece went in the bag (gold moves catalog prices) ---------- */
  function readPrices() { try { return JSON.parse(localStorage.getItem(LS_PRICES) || '{}') || {}; } catch (e) { return {}; } }
  function writePrices(m) { try { localStorage.setItem(LS_PRICES, JSON.stringify(m)); } catch (e) {} }
  function trackPrices() {
    var m = readPrices(), next = {}, moves = {};
    pieces().forEach(function (pc) {
      var unit = pc.main.variant_price;
      if (m[pc.key] != null && m[pc.key] !== unit) { moves[pc.key] = { was: m[pc.key], now: unit }; next[pc.key] = m[pc.key]; }
      else next[pc.key] = unit;
    });
    writePrices(next); S.priceMoves = moves;
  }
  function ackPrice(key) { var m = readPrices(); if (S.priceMoves[key]) { m[key] = S.priceMoves[key].now; writePrices(m); delete S.priceMoves[key]; } render(); }

  /* ---------- loading and changing ---------- */
  function refresh() {
    return Promise.all([
      fetch(ROOT + '?sections=ts-cart-data', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
      json(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
    ]).then(function (res) {
      var data = parseData(res[0]['ts-cart-data']), byKey = {};
      (res[1].items || []).forEach(function (x) { byKey[x.key] = x; });
      // line notes as the Cart API returns them (raw text; Liquid would HTML-escape them)
      data.items.forEach(function (it) { var x = byKey[it.key]; it.properties = (x && x.properties) || {}; });
      setData(data);
    });
  }
  function setData(data) {
    S.data = data;
    trackPrices();
    render();
    checkStones().then(render);
  }
  function mutate(fn, opts) {
    if (S.busy) return Promise.resolve();
    S.busy = true; S.error = ''; S.sharedMsg = ''; S.share = null; render();
    return Promise.resolve().then(fn)
      .then(function () { return giftFix(opts && opts.gift); })
      .then(refresh)
      .catch(function (e) { S.error = (e && e.message) || 'Something went wrong. Please try again.'; return refresh().catch(function () {}); })
      .then(function () { S.busy = false; render(); });
  }
  // the gift script adds/removes its own line; our add-watcher ignores those calls
  var quiet = 0;
  function giftFix(pref) {
    if (!(w.TS2Gift && w.TS2Gift.reconcile)) return Promise.resolve();
    quiet++;
    return w.TS2Gift.reconcile(pref).catch(function () {}).then(function () { quiet--; }, function () { quiet--; });
  }
  function removeKeys(keys) {
    // by position in the live cart (keys can change), last line first so positions stay valid
    var mine = ((S.data && S.data.items) || []).filter(function (x) { return keys.indexOf(x.key) > -1; });
    return mine.reduce(function (p, it) { return p.then(function (acc) { return lineOf(it).then(function (l) { if (l) acc.push(l); return acc; }); }); }, Promise.resolve([]))
      .then(function (lines) {
        lines.sort(function (a, b) { return b - a; });
        return lines.reduce(function (p, l) { return p.then(function () { return post('change', { line: l, quantity: 0 }); }); }, Promise.resolve());
      });
  }
  function cleanProps(p, extra) {
    var o = {};
    Object.keys(p || {}).forEach(function (k) { if (k !== '_selectedImage') o[k] = p[k]; });
    Object.keys(extra || {}).forEach(function (k) { if (extra[k] == null) delete o[k]; else o[k] = extra[k]; });
    return o;
  }
  // Shopify can re-key lines when the bag changes, so find the line again in the live cart before changing it:
  // by key, else by the same variant with the same notes. Returns its 1-based line number, or 0.
  function lineOf(it) {
    return json(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (c) {
      var items = c.items || [], i = -1, sig = JSON.stringify(it.properties || {});
      items.forEach(function (x, n) { if (i < 0 && x.key === it.key) i = n; });
      if (i < 0) items.forEach(function (x, n) { if (i < 0 && String(x.variant_id) === String(it.variant_id) && JSON.stringify(x.properties || {}) === sig) i = n; });
      return i + 1;
    });
  }
  function setQty(it, q, props) {
    return lineOf(it).then(function (line) {
      if (!line) throw new Error('This piece changed in another tab. Your bag has been refreshed.');
      var body = { line: line, quantity: q }; if (props) body.properties = props;
      return post('change', body);
    });
  }
  // a different variant (or a sibling product) replaces the line; engraving and other add-ons stay linked
  function swapVariant(pc, v, extra) {
    var it = pc.main;
    var props = cleanProps(it.properties, Object.assign({ Sku: it.properties && it.properties.Sku != null ? (v.s || null) : null }, extra || {}));
    return post('add', { items: [{ id: v.id, quantity: it.quantity, properties: props }] })
      .then(function () { return setQty(it, 0); });
  }

  /* ---------- drawing ---------- */
  var ICON = {
    close: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>',
    truck: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>',
    ret: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M4 12a8 8 0 1 0 3-6.2M4 4v4h4"/></svg>',
    ring: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><circle cx="12" cy="12" r="7"/><circle cx="12" cy="12" r="3"/></svg>',
    shield: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/></svg>',
    lock: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="5" y="11" width="14" height="10"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>',
    share: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 15V3M7 8l5-5 5 5M5 12v8h14v-8"/></svg>',
    gift: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M3 9h18v4H3zM5 13h14v8H5zM12 9v12M12 9c-1.5-3-5-4-5-1.5S10.5 9 12 9zm0 0c1.5-3 5-4 5-1.5S13.5 9 12 9z" stroke-linejoin="round"/></svg>'
  };

  function titleOf(pc) {
    var it = pc.main, p = it.properties || {};
    if (pc.w) return String(p._pname || pc.w.setting_product_name || it.title).replace(/^White Diamond\s+/i, '');
    return it.title;
  }
  function eyebrowOf(pc) {
    var it = pc.main;
    if (pc.w) return (it.properties || {})._earring_product ? 'Earrings designed by you' : (it.properties || {})._necklace_product ? 'Necklace designed by you' : 'Designed by you';
    if (it.quality) { var t = it.quality.tiers.filter(function (x) { return x.current; })[0]; if (t) return (it.quality.group === 'lab' ? 'Lab grown' : 'Natural') + ' · ' + t.label; }
    return String(it.type || '').split(',')[0];
  }
  function specsOf(pc) {
    var it = pc.main, p = it.properties || {}, x = pc.w, rows = [];
    if (x) {
      var metal = x.setting_selected_metal || '';
      if (p._earring_product) rows.push('Setting: ' + metal);
      else rows.push('Setting: ' + metal + (p.Size ? ' · Size ' + p.Size : p.Chain_Length ? ' · ' + p.Chain_Length : ''));
      var dtype = p._diamond_type_new || 'Lab Grown';
      if (p.Diamonds) rows.push('Diamonds: ' + p.Diamonds);
      else rows.push('Diamond: ' + ct(x.stone_carat || p._stoneCarat) + ' ct ' + dtype + ' ' + cap(x.stone_shape || p._stoneShape) + ' · ' +
        [p._stoneColor || x.stone_color, p._stoneClarity || x.stone_clarity].filter(Boolean).join(' · ') + (p._certificate_type ? ' · ' + p._certificate_type : ''));
      if (p.Includes) rows.push(p.Includes);
    } else {
      // options that cannot be changed here are shown as text
      (it.options || []).forEach(function (name, i) {
        var vals = uniq((it.variants || []).map(function (v) { return v.o[i]; }));
        if (vals.length < 2) { var val = (it.variant_title || '').split(' / ')[i]; if (val && val !== 'Default Title') rows.push(name + ': ' + val); }
      });
      Object.keys(p).forEach(function (k) {
        if (k.charAt(0) === '_' || k === 'Sku' || /^option-/.test(k) || p[k] === '' || p[k] == null) return;
        rows.push(k.replace(/_/g, ' ') + ': ' + p[k]);
      });
    }
    if (pc.engraving) {
      var e = pc.engraving.properties || {};
      var txt = [e['Engrave Front Text'] ? 'front "' + e['Engrave Front Text'] + '"' : '', e['Engrave Back Text'] ? 'back "' + e['Engrave Back Text'] + '"' : ''].filter(Boolean).join(', ');
      rows.push('Engraving' + (txt ? ': ' + txt : '') + ' (' + money(pc.engraving.line_price) + ', not returnable)');
    }
    return rows;
  }
  function curOpts(it) {
    var v = (it.variants || []).filter(function (x) { return String(x.id) === String(it.variant_id); })[0];
    return v ? v.o : String(it.variant_title || 'Default Title').split(' / ');
  }
  function uniq(a) { var o = []; a.forEach(function (x) { if (x != null && o.indexOf(x) < 0) o.push(x); }); return o; }

  function optionControls(pc) {
    var it = pc.main;
    if (pc.w || !it.variants || it.variants.length < 2) return '';
    var curO = curOpts(it);
    return (it.options || []).map(function (name, i) {
      var vals = uniq(it.variants.map(function (v) { return v.o[i]; }));
      if (vals.length < 2) return '';
      if (vals.every(function (x) { return !isNaN(parseFloat(x)); })) vals.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
      var id = 'tsc-o-' + it.line + '-' + i;
      return '<label class="tsc-chip" for="' + id + '"><span>' + esc(name) + '</span><select id="' + id + '" data-act="opt" data-key="' + esc(it.key) + '" data-i="' + i + '">' +
        vals.map(function (val) {
          var match = it.variants.filter(function (v) { return v.o[i] === val && v.o.every(function (o, j) { return j === i || o === curO[j]; }); })[0];
          var off = match && !match.a;
          return '<option value="' + esc(val) + '"' + (val === curO[i] ? ' selected' : '') + '>' + esc(val) + (off ? ' (made to order)' : '') + '</option>';
        }).join('') + '</select></label>';
    }).join('');
  }
  // stone quality and carat sizes that are separate products: a select like any option; choosing swaps the product
  function siblingControls(pc) {
    var it = pc.main; if (pc.w) return '';
    var out = '', curO = curOpts(it);
    var q = it.quality;
    if (q && q.tiers.length > 1) {
      var id = 'tsc-q-' + it.line;
      out += '<label class="tsc-chip" for="' + id + '"><span>Stone quality</span><select id="' + id + '" data-act="qsel" data-key="' + esc(it.key) + '">' +
        q.tiers.map(function (t) {
          var sv = t.current ? null : siblingVariant(t, curO);
          if (!t.current && !sv) return '';
          return '<option value="' + esc(t.handle) + '"' + (t.current ? ' selected' : '') + '>' + esc(t.label) + (sv ? ' (' + signed(sv.p - it.variant_price) + ')' : '') + '</option>';
        }).join('') + '</select></label>';
    }
    var sz = sizesOf(it);
    if (sz.length > 1) {
      var id2 = 'tsc-c-' + it.line;
      out += '<label class="tsc-chip" for="' + id2 + '"><span>Carat</span><select id="' + id2 + '" data-act="ssel" data-key="' + esc(it.key) + '">' +
        sz.map(function (z) {
          return '<option value="' + esc(z.handle) + '"' + (z.current ? ' selected' : '') + '>' + esc(z.cw) + ' ct' + (z.sv ? ' (' + signed(z.sv.p - it.variant_price) + ')' : '') + '</option>';
        }).join('') + '</select></label>';
    }
    return out;
  }
  // the photo of the line's exact variant (so a metal change shows the new metal). Product photos are named by SKU:
  // <SKU>-1 (rings drop the size part), on Shopify (sku_image from the bag data) or on our photo service, like the product page.
  var PHOTOS = 'https://1yi00t63hl.execute-api.us-east-1.amazonaws.com/v1/', photos = {};
  function skuPhoto(it) {
    if (!it || it.dyo || !it.sku) return '';
    if (it.sku_image) return it.sku_image;
    var pid = it.product_id, l = photos[pid];
    if (l === undefined) {
      photos[pid] = null;
      fetch(PHOTOS + pid).then(function (r) { return r.json(); })
        .then(function (list) { photos[pid] = Array.isArray(list) ? list : []; if (skuPhoto(it)) render(); })
        .catch(function () { photos[pid] = []; });
      return '';
    }
    if (!l) return '';
    var sku = String(it.sku).toLowerCase(), keys = [sku, sku.split('-')[0]], hit = '';
    keys.forEach(function (k) {
      if (hit) return;
      var re = new RegExp('/' + k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '-1\\.(png|jpe?g|webp)$', 'i');
      hit = l.filter(function (u) { return re.test(String(u).split('?')[0]); })[0] || '';
    });
    return hit;
  }
  function photoOf(it) { return skuPhoto(it) || it.image || ''; }
  // photo for a swapped-in sibling: its own photo, else keep the one the shopper saw
  function imgFor(img, pc) {
    if (img) return String(img).replace(/&amp;/g, '&');
    var p = pc.main.properties || {};
    return p._selectedImage || p._image || pc.main.image || null;
  }
  function signed(delta) { return delta === 0 ? 'same price' : (delta > 0 ? '+' : '−') + moneyRound(Math.abs(delta)); }
  // the carat sizes that can be swapped to (same metal and other options), smallest first
  function sizesOf(it) {
    var curO = curOpts(it);
    return (it.sizes || []).map(function (z) { return { cw: z.cw, handle: z.handle, current: z.current, image: z.image, sv: z.current ? null : siblingVariant(z, curO) }; })
      .filter(function (z) { return z.current || z.sv; })
      .sort(function (a, b) { return parseFloat(a.cw) - parseFloat(b.cw); });
  }
  // design-your-own ring, necklace or earrings: change the metal. The piece is made in the builder (photos, price,
  // the product), so the bag opens it there with the same diamond(s) and size; Add to bag replaces this line
  // (for our own matched pairs: the whole bundle of setting + two diamond lines).
  var setv = {};
  function dyoMetalControl(pc) {
    var it = pc.main, p = it.properties || {}, x = pc.w;
    if (!x || !x.setting_product_handle) return '';
    var h = x.setting_product_handle, vs = setv[h];
    if (vs === undefined) {
      setv[h] = null;
      fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { setv[h] = j && j.variants ? j.variants.filter(function (v) { return v.available; }).map(function (v) { return { id: v.id, title: v.title, price: v.price, sku: v.sku }; }) : []; render(); })
        .catch(function () { setv[h] = []; });
      return '';
    }
    if (!vs || vs.length < 2) return '';
    dyoPrefetch(pc);
    var cur = String(x.setting_selected_metal || ''), id = 'tsc-m-' + it.line, curV = vs.filter(function (v) { return v.title === cur; })[0];
    return '<label class="tsc-chip" for="' + id + '"><span>Metal</span><select id="' + id + '" data-act="dyometal" data-key="' + esc(it.key) + '">' +
      (curV ? '' : '<option selected>' + esc(cur) + '</option>') +
      vs.map(function (v) {
        var d = curV ? v.price - curV.price : 0;
        return '<option value="' + v.id + '"' + (v.title === cur ? ' selected' : '') + '>' + esc(v.title) + (curV && v.title !== cur && d ? ' (' + signed(d) + ')' : '') + '</option>';
      }).join('') + '</select></label>';
  }
  function dyoMetal(pc, vid) {
    var x = pc.w, p = pc.main.properties || {}, h = x.setting_product_handle;
    var v = (setv[h] || []).filter(function (z) { return String(z.id) === String(vid); })[0]; if (!v) return;
    var pendant = !!p._necklace_product, earring = !!p._earring_product, own = !!pc.bundle;
    var piece = pendant ? 'necklace' : earring ? 'earrings' : 'ring';
    var x0 = pc.w, cachedList = phCache[x0.setting_product_id] && phCache[x0.setting_product_id].list;
    var preview = cachedList ? dyoPhoto(cachedList, v.sku || '', String(x0.stone_shape || p._stoneShape || 'Round'), v.title,
      earring ? ((parseFloat(x0.stone_carat) || 0) + (parseFloat(x0.stone_carat1) || 0)) / 2 || 1 : parseFloat(x0.stone_carat || p._stoneCarat) || 1, earring) : '';
    S.working = { key: pc.key, text: 'Making your ' + piece + ' in ' + v.title + '…', img: preview };
    var failed = null;
    mutate(function () {
      return dyoRebuild(pc, v).catch(function (e) { failed = e; if (e && e.gone) { var g = new Error('That ' + (earring ? 'pair' : 'diamond') + ' is no longer available. Choose a similar one below.'); throw g; } });
    }).then(function () {
      S.working = null;
      if (failed && failed.after) { S.error = 'Your ' + piece + ' was updated, but please check your bag: refresh the page if you see it twice.'; return render(); }
      if (failed && !failed.gone) { if (w.console) console.warn('Bag metal change, opening the builder instead:', failed); return dyoMetalInBuilder(pc, v); }   // anything unexpected: finish it on the builder page, as before
      S.checked = false; return checkStones().then(render);
    });
  }
  // the old way, kept as the fallback: open the builder with the same diamond and size; Add to bag replaces the line
  function dyoMetalInBuilder(pc, v) {
    var x = pc.w, p = pc.main.properties || {}, h = x.setting_product_handle;
    var pendant = !!p._necklace_product, earring = !!p._earring_product, own = !!pc.bundle;
    var stKey = pendant ? 'ts2_pendant' : earring ? 'ts2_earring' : 'ts2_ring';
    var shape = x.stone_shape || p._stoneShape, carat = parseFloat(x.stone_carat || p._stoneCarat) || 1;
    var natural = /natural/i.test(p._diamond_type_new || '');
    var st = {};
    try { st = JSON.parse(localStorage.getItem(stKey) || '{}') || {}; } catch (e) {}
    st.setting = { handle: h, pid: x.setting_product_id, vid: v.id, sku: '', metal: v.title, price: v.price,
      design: String(x.setting_product_name || '').split(' - ').pop(), title: x.setting_product_name, shape: shape, shapes: x.setting_allowed_shapes,
      minCt: parseFloat(x.setting_min_carat_size) || 0.3, maxCt: parseFloat(x.setting_max_carat_size) || 4, image: '', link: '/products/' + h + '?variant=' + v.id };
    st.diamond = !earring ? { id: x.stone_id, type: natural ? 'natural' : 'lab', shape: shape, carat: carat }
      : own && x.stone_id1 ? { id: 'm' + x.stone_id1 + '-' + x.stone_id, own: true, pair: true, type: 'lab', shape: shape, carat: carat }
      : { id: x.stone_id, pair: true, type: 'pair', shape: shape, carat: carat };
    try {
      localStorage.setItem(stKey, JSON.stringify(st)); sessionStorage.setItem('ts2ReplaceLine', pc.key); sessionStorage.setItem('ts2ReplaceVariant', String(pc.main.variant_id));
      if (own) sessionStorage.setItem('ts2ReplaceBundle', pc.bundle);
    } catch (e) {}
    var size = earring ? '' : pendant ? p.Chain_Length : p.Size;
    S.leaving = 'Opening your ' + (pendant ? 'necklace' : earring ? 'earrings' : 'ring') + ' in ' + v.title + '…'; render();
    location.href = (pendant ? '/pages/build-your-necklace' : earring ? '/pages/build-your-earrings' : '/pages/build-your-ring') + '?step=complete&fresh=1' + (natural ? '&dt=natural' : '') + (size ? '&size=' + encodeURIComponent(size) : '');
  }
  /* Make a design-your-own piece in another metal right in the bag, with the same steps as the builder
     (assets/ts2-builder.js addToBag): the setting photo for the new metal, the diamond still for sale, the piece
     made by the diamond service (/ring), the same line notes with the setting fields updated. Then the old line goes.
     Our own matched earring pairs use the setting product itself, so only that line's variant changes. */
  function dyoPhoto(list, sku, shape, metal, carat, earring) {
    var opts = [[0.33, '1-3'], [0.5, '1-2'], [0.75, '3-4'], [1, '1'], [1.5, '11-2'], [2, '2'], [3, '3'], [4, '4']];
    var tk = opts.reduce(function (a, b) { return Math.abs(b[0] - carat) < Math.abs(a[0] - carat) ? b : a; })[1];
    function pre(t, mk) {
      return earring ? 'dyoe_setting_' + String(sku).toLowerCase() + '_' + t + '_' + mk + '-'
                     : 'dyor_setting_' + String(sku).toLowerCase() + '_' + String(shape).toLowerCase() + '_' + t + '_' + mk + '-';
    }
    function pick(t, mk) {
      return (list || []).filter(function (u) { return /\.(jpe?g|png|webp)$/i.test(u) && String(u).split('/').pop().toLowerCase().indexOf(pre(t, mk)) === 0; })
        .sort(function (a, b) { return (parseInt(a.split('-').pop(), 10) || 0) - (parseInt(b.split('-').pop(), 10) || 0); });
    }
    var mk = String(metal || '').toLowerCase().replace(/\s+/g, ''), wg = earring ? '14kwhitegold' : '18kwhitegold';
    var out = pick(tk, mk);
    if (!out.length && /platinum/i.test(metal)) out = pick(tk, wg);
    if (!out.length) out = pick('1', mk);
    if (!out.length && /platinum/i.test(metal)) out = pick('1', wg);
    return out[0] || '';
  }
  function dyoAccent(sd, carat, shape) {
    var key = '1', cap = function (t) { t = String(t || ''); return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase(); };
    for (var i = 0; i < (sd.sizes || []).length; i++) { if (carat <= parseFloat(sd.sizes[i].value)) { key = sd.sizes[i].key; break; } }
    var hit = (sd.accents || []).filter(function (a) { return a.carat === key && cap(a.shape) === cap(shape); })[0] ||
      (sd.accents || []).filter(function (a) { return a.carat === '1' && cap(a.shape) === cap(shape); })[0];
    return hit ? hit.html : '';
  }
  // setting data + setting photos, fetched once per setting and early (when the bag shows the piece), so a metal
  // change only waits for the diamond service
  var sdCache = {}, phCache = {};
  function dyoData(h) { return sdCache[h] || (sdCache[h] = json(ROOT + 'products/' + encodeURIComponent(h) + '?view=ts2-dyor-data').catch(function (e) { delete sdCache[h]; throw e; })); }
  function dyoPhotos(pid) { return phCache[pid] || (phCache[pid] = fetch(PHOTOS + pid).then(function (r) { return r.json(); }).then(function (l) { phCache[pid].list = Array.isArray(l) ? l : []; return phCache[pid].list; }).catch(function () { return []; })); }
  function dyoPrefetch(pc) {
    var x = pc.w; if (!x || !x.setting_product_handle) return;
    var go = function () { dyoData(x.setting_product_handle).catch(function () {}); dyoPhotos(x.setting_product_id); };
    if (w.requestIdleCallback) w.requestIdleCallback(go, { timeout: 2000 }); else setTimeout(go, 300);
  }
  function dyoRebuild(pc, v) {
    var it = pc.main, p = it.properties || {}, x = pc.w, h = x.setting_product_handle;
    var pendant = !!p._necklace_product, earring = !!p._earring_product, own = !!pc.bundle;
    var natural = /natural/i.test(p._diamond_type_new || ''), kind = earring && !own ? 'pair' : natural ? 'natural' : 'lab';
    var shape = String(x.stone_shape || p._stoneShape || 'Round'), carat = parseFloat(x.stone_carat || p._stoneCarat) || 1;
    if (earring) carat = (parseFloat(x.stone_carat) || 0) + (parseFloat(x.stone_carat1) || 0) || carat;
    var sd, sv, img;
    // the diamond check runs alongside the setting data (own pairs don't need it: their diamonds don't change)
    var stoneP = own ? Promise.resolve(null) : diamondFetch(x.stone_id, kind);
    return Promise.all([
      // (no Accept: application/json on this one, or Shopify answers with its own product JSON instead of this view)
      dyoData(h), dyoPhotos(x.setting_product_id), stoneP
    ]).then(function (res) {
      sd = res[0];
      sv = (sd.variants || []).filter(function (z) { return String(z.id) === String(v.id); })[0];
      if (!sv || !sv.available) throw new Error('metal');
      img = dyoPhoto(res[1], sv.sku, shape, sv.title, earring ? carat / 2 : carat, earring) || sd.image || '';
      if (own) return null;
      // the diamond(s) must still be for sale
      return Promise.resolve([res[2]]).then(function (rs) {
        if (rs.some(function (r) { return r && (r.gone || (r.rec && !(r.rec.Diamond_ID || r.rec.diamond_id || r.rec.Diamond_ID2 || r.rec.diamond_id2))); })) { var e = new Error('gone'); e.gone = true; throw e; }
        var base = kind === 'pair' ? 'diamonds/apiservices/dyoe/new_api' : kind === 'natural' ? 'diamonds' : 'diamonds/apiservices/new_api';
        var body = kind === 'pair'
          ? { diamond_id: x.stone_id, diamond_id1: x.stone_id1, variant_id: sv.id, product_image: img }
          : { diamond_id: x.stone_id, variant_id: sv.id, product_image: img, cad_no: '', center_stone: '', accent_stone_val: dyoAccent(sd, carat, shape) };
        return json(kind === 'pair' ? DAPI + base + '/ring' : NAT_API + '/ring' + (kind === 'natural' ? '' : '?kind=lab'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-API-Key': DKEY }, body: JSON.stringify(body) });
      });
    }).then(function (product) {
      var newVid = own ? sv.id : product && product.variants && product.variants[0] && product.variants[0].id;
      if (!newVid) throw new Error('ring');
      if (!own && product.variants[0].price != null) {
        // never put a piece in the bag at a price that differs from setting + diamond(s)
        var built = Math.round(parseFloat(product.variants[0].price) * 100);
        var stone = Math.round((parseFloat(x.stone_price) || 0) * 100);
        if (kind === 'pair') stone = Math.round(((parseFloat(x.stone_price) || 0) + (parseFloat(x.stone_price1) || 0)) * 100);
        if (stone && Math.abs(built - (sv.price + stone)) > 300) throw new Error('price');
      }
      var info = Object.assign({}, x, {
        setting_image_url: img, setting_variant_id: sv.id, setting_variant_sku: sv.sku, setting_variant_price: sv.price, setting_selected_metal: sv.title,
        setting_material_cost: (sv.cost.components / 100).toFixed(2), setting_labor_cost: ((sv.cost.crafting + sv.cost.design) / 100).toFixed(2),
        setting_logistic_cost: ((sv.cost.packaging + sv.cost.duties) / 100).toFixed(2)
      });
      var props = Object.assign({}, p, { _wizardInfo: JSON.stringify(JSON.stringify(info)), _pid: sv.id, _selectVariantPrice: sv.price, _image: img });
      delete props._selectedImage;
      if (p._bridal_set && sd.bridal && sd.bridal.bands && sd.bridal.bands[0]) {
        var b = sd.bridal.bands[0], size = p.Size || '';
        var bv = b.variants.filter(function (z) { return z.title === sv.title + ' / ' + size; })[0] || b.variants.filter(function (z) { return z.title.indexOf(sv.title) === 0; })[0];
        props['Includes'] = 'Matching band (The ' + b.design + '), ' + sv.title + ', size ' + size;
        if (bv) props['_band_variant_id'] = bv.id;
      }
      // the diamond service hands back the product it already made for this setting + diamond: if that is the very
      // line in the bag, only its notes change (adding it again would merge into this line, and removing would drop it)
      if (String(newVid) === String(it.variant_id)) return setQty(it, it.quantity, props);
      return post('add', { items: [{ id: parseInt(newVid, 10), quantity: it.quantity, properties: props }] }).then(function () {
        var upd = {}; upd[it.key] = 0;
        return post('update', { updates: upd }).then(function (c) {
          if ((c.items || []).some(function (q) { return q.key === it.key; })) return setQty(it, 0);   // re-keyed: find it by position
        }).catch(function () { return setQty(it, 0); }).catch(function (e) { e.after = true; throw e; });
      }).then(function () {
        if (!own) return;
        // our own pairs: the two diamond lines say which earrings they are for
        var parts = pc.parts.filter(function (q) { return q !== it && q.properties && q.properties.For; });
        return parts.reduce(function (pr, q) {
          return pr.then(function () { return setQty(q, q.quantity, Object.assign({}, q.properties, { For: String(q.properties.For).replace(/\(([^)]*)\)\s*$/, '(' + sv.title + ')') })); });
        }, Promise.resolve());
      });
    });
  }
  function sizeControl(pc) {
    var it = pc.main, p = it.properties || {};
    if (!pc.w || p._earring_product || p._necklace_product) return '';
    var sizes = String(p._allowedSize || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (sizes.length < 2) return '';
    if (p.Size && sizes.indexOf(String(p.Size)) < 0) sizes.unshift(String(p.Size));
    var id = 'tsc-s-' + it.line;
    return '<label class="tsc-chip" for="' + id + '"><span>Size</span><select id="' + id + '" data-act="size" data-key="' + esc(it.key) + '">' +
      sizes.map(function (s) { return '<option' + (String(p.Size) === s ? ' selected' : '') + '>' + esc(s) + '</option>'; }).join('') + '</select></label>';
  }
  function qtyControl(pc) {
    var it = pc.main;
    if (pc.w || pc.bundle || pc.parts.length > 1) return '';
    return '<div class="tsc-qty" role="group" aria-label="Quantity"><button type="button" data-act="qty" data-key="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="One less"' + (it.quantity < 2 ? ' disabled' : '') + '>−</button>' +
      '<span aria-live="polite">' + it.quantity + '</span><button type="button" data-act="qty" data-key="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="One more">+</button></div>';
  }
  // upsells on each piece: a better stone grade (sibling product, same group) or a bigger carat weight (variant)
  function deltaText(delta) { return delta <= 0 ? 'at no extra cost' : 'for ' + moneyRound(delta) + ' more'; }
  function qualityBlock(pc) {
    var it = pc.main, q = it.quality;
    if (pc.w) return '';
    var rows = [];
    var dot = '<span class="tsc-up__ic" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M6 3h12l3 5-9 13L3 8z"/><path d="M3 8h18M9 3l3 5 3-5M12 8v13"/></svg></span>';
    function row(media, title, sub, act, key, attr, btn) {
      return '<div class="tsc-up">' + media + '<div class="tsc-up__t"><b>' + title + '</b><span>' + sub + '</span></div>' +
        '<button type="button" class="tsc-up__b" data-act="' + act + '" data-key="' + esc(key) + '" ' + attr + '>' + btn + '</button></div>';
    }
    // a finer stone grade (sibling product, same group)
    if (q && q.tiers.length > 1) {
      var curIdx = -1; q.tiers.forEach(function (t, i) { if (t.current) curIdx = i; });
      if (curIdx > -1 && curIdx < q.tiers.length - 1) {
        var curO = curOpts(it), ups = [];
        q.tiers.slice(curIdx + 1).forEach(function (t) { var sv = siblingVariant(t, curO); if (sv) ups.push({ t: t, delta: sv.p - it.variant_price }); });
        if (ups.length) {
          var f = ups[0];
          var media = f.t.media ? '<img class="tsc-up__img" src="' + esc(f.t.media) + '" alt="" width="36" height="36" decoding="async">' : dot;
          rows.push(row(media, 'Upgrade to ' + esc(f.t.label) + ' ' + deltaText(f.delta), 'Same design, a finer ' + (q.group === 'lab' ? 'lab grown stone' : 'stone') + '.',
            'quality', it.key, 'data-h="' + esc(f.t.handle) + '"', 'Upgrade'));
        }
      }
    }
    // a bigger stone: a carat option on this product, or carat sizes sold as separate products
    var ci = (it.options || []).map(function (n) { return /carat/i.test(n); }).indexOf(true);
    if (ci > -1 && it.variants && it.variants.length > 1) {
      var co = curOpts(it), curCt = parseFloat(co[ci]);
      var bigger = it.variants.filter(function (v) { return v.a && parseFloat(v.o[ci]) > curCt && v.o.every(function (o, j) { return j === ci || o === co[j]; }); })
        .sort(function (x, y) { return parseFloat(x.o[ci]) - parseFloat(y.o[ci]); })[0];
      if (bigger) rows.push(row(dot, 'Go up to ' + esc(bigger.o[ci]) + ' ' + deltaText(bigger.p - it.variant_price), 'Same piece, a bigger center stone.',
        'upsize', it.key, 'data-v="' + bigger.id + '"', 'Go bigger'));
    } else {
      var sz = sizesOf(it), at = -1; sz.forEach(function (z, i) { if (z.current) at = i; });
      var up = at > -1 ? sz[at + 1] : null;
      if (up) rows.push(row(dot, 'Go up to ' + esc(up.cw) + ' ct ' + deltaText(up.sv.p - it.variant_price), 'Same piece, bigger stones.',
        'upsize-sib', it.key, 'data-h="' + esc(up.handle) + '"', 'Go bigger'));
    }
    if (!rows.length) return '';
    return '<div class="tsc-ups"><div class="tsc-lbl">Make it yours</div>' + rows.join('') + '</div>';
  }
  function siblingVariant(t, curO) {
    var vs = t.variants || [];
    return vs.filter(function (v) { return v.a && v.o.every(function (o, j) { return o === curO[j]; }); })[0] ||
      vs.filter(function (v) { return v.o.every(function (o, j) { return o === curO[j]; }); })[0] ||
      vs.filter(function (v) { return v.a && v.o[0] === curO[0]; })[0] || null;
  }
  function makeBlock(pc) {
    var m = makeOf(pc);
    if (!m) return pc.w && !S.checked ? '<div class="tsc-make tsc-muted">Checking the diamond…</div>' : '';
    var open = !!S.openMake[pc.key];
    var make = Math.round(m.diff * RATE);
    var rows = m.lines.map(function (l) { return '<div class="tsc-brk__r"><span>' + esc(l.label) + '</span><span>' + money(Math.round(l.cents * RATE)) + '</span></div>'; }).join('');
    return '<div class="tsc-make"><span class="tsc-muted">We make</span> ' + esc(m.short) + ' (' + moneyRound(make) + ')' +
      ' <button type="button" class="tsc-link" data-act="make" data-key="' + esc(pc.key) + '" aria-expanded="' + open + '">' + (open ? 'Hide' : 'See the costs') + '</button></div>' +
      (open ? '<div class="tsc-brk">' + rows + '<div class="tsc-brk__r tsc-brk__r--sum"><span>We make</span><span>' + money(make) + '</span></div>' +
        (pc.main.quantity > 1 ? '<div class="tsc-brk__note">Per piece.</div>' : '') + '</div>' : '');
  }
  function deliveryOf(pc) {
    var p = pc.main.properties || {};
    var dd = p._Delivery || p._deliver_date || p._stoneDelivery || '';
    if (!dd || /^\d+$/.test(String(dd))) return '';
    return '<div class="tsc-ship">' + ICON.truck + '<span>Estimated delivery: ' + esc(dd) + '</span></div>';
  }
  function holdLine(pc) {
    if (!S.holdUntil[pc.key] || S.sold[pc.key]) return '';
    return '<div class="tsc-ship"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2M9 2h6"/></svg>' +
      '<span>Your diamond is reserved for you for <b data-tsc-hold="' + esc(pc.key) + '">30:00</b></span></div>';
  }
  function soldBlock(pc) {
    if (S.heldElse[pc.key] && !S.sold[pc.key]) {
      var pe = (pc.main.properties || {})._earring_product;
      return '<div class="tsc-alert" role="status"><div class="tsc-alert__t">Another shopper is checking out with this ' + (pe ? 'pair' : 'diamond') + '</div>' +
        '<p>It is held for them for up to 30 minutes. Pick a similar ' + (pe ? 'pair' : 'diamond') + ' now, or check back shortly.</p>' +
        '<div class="tsc-alert__b"><button type="button" class="tsc-btn tsc-btn--dark" data-act="swapd" data-key="' + esc(pc.key) + '">Choose a similar ' + (pe ? 'pair' : 'diamond') + '</button>' +
        '<button type="button" class="tsc-btn" data-act="remove" data-keys="' + esc(pc.keys.join('|')) + '">Remove</button></div></div>';
    }
    if (!S.sold[pc.key]) return '';
    var p = pc.main.properties || {};
    var what = p._earring_product ? 'A diamond in this pair' : 'The diamond in this piece';
    return '<div class="tsc-alert" role="status"><div class="tsc-alert__t">' + what + ' was just sold</div>' +
      '<p>Diamonds sell fast. Your setting and size are saved. Pick a similar ' + (p._earring_product ? 'pair' : 'diamond') + ' and we will update your bag.</p>' +
      '<div class="tsc-alert__b"><button type="button" class="tsc-btn tsc-btn--dark" data-act="swapd" data-key="' + esc(pc.key) + '">Choose a similar ' + (p._earring_product ? 'pair' : 'diamond') + '</button>' +
      '<button type="button" class="tsc-btn" data-act="remove" data-keys="' + esc(pc.keys.join('|')) + '">Remove</button></div></div>';
  }
  function priceMoveBlock(pc) {
    var mv = S.priceMoves[pc.key]; if (!mv) return '';
    // a lower price is good news (a promotion, or gold and diamond costs came down): no need to ask
    if (mv.now < mv.was) {
      return '<div class="tsc-alert" role="status"><p>Good news: this piece costs less than when you added it. It is now <b>' + money(mv.now) + '</b>, was ' + money(mv.was) + '.</p>' +
        '<div class="tsc-alert__b"><button type="button" class="tsc-btn" data-act="ackprice" data-key="' + esc(pc.key) + '">Got it</button></div></div>';
    }
    return '<div class="tsc-alert" role="status"><p>The price of this piece went up since you added it. Our prices follow what gold and diamonds cost us. It is now <b>' + money(mv.now) + '</b>, was ' + money(mv.was) + '.</p>' +
      '<div class="tsc-alert__b"><button type="button" class="tsc-btn tsc-btn--dark" data-act="ackprice" data-key="' + esc(pc.key) + '">Keep it</button>' +
      '<button type="button" class="tsc-btn" data-act="remove" data-keys="' + esc(pc.keys.join('|')) + '">Remove</button></div></div>';
  }
  function pieceHTML(pc, mode) {
    var it = pc.main, img = S.working && S.working.key === pc.key && S.working.img ? S.working.img : photoOf(it);
    var href = pc.w ? null : it.url;
    var media = '<div class="tsc-item__img">' + (img ? '<img src="' + esc(img) + '" alt="" width="200" height="240" loading="lazy">' : '') + '</div>';
    var specs = specsOf(pc).map(function (s) { return '<div>' + esc(s) + '</div>'; }).join('');
    var controls = siblingControls(pc) + optionControls(pc) + dyoMetalControl(pc) + sizeControl(pc);
    var dyoLinks = pc.w ? '<button type="button" class="tsc-chip tsc-chip--btn" data-act="swapd" data-key="' + esc(pc.key) + '">Change diamond</button>' : '';
    var price = '<div class="tsc-item__price">' + (pc.original > pc.price ? '<s>' + money(pc.original) + '</s> ' : '') + money(pc.price) + '</div>';
    return '<article class="tsc-item' + (S.sold[pc.key] ? ' is-sold' : '') + '" data-piece="' + esc(pc.key) + '">' +
      (href ? '<a class="tsc-item__media" href="' + esc(href) + '" tabindex="-1" aria-hidden="true">' + media + '</a>' : '<div class="tsc-item__media">' + media + '</div>') +
      '<div class="tsc-item__body">' +
        '<div class="tsc-item__top"><div class="tsc-item__head">' + (eyebrowOf(pc) ? '<div class="tsc-lbl">' + esc(eyebrowOf(pc)) + '</div>' : '') +
          '<h3 class="tsc-item__title">' + (href ? '<a href="' + esc(href) + '">' + esc(titleOf(pc)) + '</a>' : esc(titleOf(pc))) + '</h3></div>' + price + '</div>' +
        '<div class="tsc-item__specs">' + specs + '</div>' +
        (S.working && S.working.key === pc.key ? '<div class="tsc-working" role="status"><span class="tsc-spin" aria-hidden="true"></span>' + esc(S.working.text) + '</div>' : '') +
        soldBlock(pc) + priceMoveBlock(pc) +
        (controls || dyoLinks || qtyControl(pc) ? '<div class="tsc-item__ctl">' + controls + dyoLinks + qtyControl(pc) + '</div>' : '') +
        makeBlock(pc) + qualityBlock(pc) + holdLine(pc) + deliveryOf(pc) +
        '<div class="tsc-item__acts"><button type="button" class="tsc-link" data-act="save" data-key="' + esc(pc.key) + '">Save to wishlist</button>' +
        '<button type="button" class="tsc-link tsc-muted" data-act="remove" data-keys="' + esc(pc.keys.join('|')) + '">Remove</button></div>' +
      '</div></article>';
  }
  function giftHTML() {
    var cfg = giftCfg(); if (!cfg || !S.data) return '';
    var list = pieces(); if (!list.length) return '';
    var qual = Math.round(list.reduce(function (a, pc) { return a + pc.price; }, 0) / RATE);
    var tiers = cfg.tiers.filter(function (t) { return t.gifts && t.gifts.length; });
    if (!tiers.length) return '';
    var tier = null; cfg.tiers.forEach(function (t) { if (qual >= t.min && t.gifts.length) tier = t; });
    var next = tiers.filter(function (t) { return t.min > qual; })[0];
    var max = tiers[tiers.length - 1].min || 1;
    var pct = Math.min(100, Math.round(qual * 100 / max));
    var marks = tiers.map(function (t) { return '<span class="tsc-tier__m' + (qual >= t.min ? ' is-on' : '') + '" style="left:' + Math.min(100, Math.round(t.min * 100 / max)) + '%"></span>'; }).join('');
    var head = tier ? (next ? 'Your free gift is unlocked. Add ' + moneyRound(Math.round((next.min - qual) * RATE)) + ' more for the next tier.' : 'Your top-tier gift is unlocked.')
      : 'Add ' + moneyRound(Math.round((next.min - qual) * RATE)) + ' more to get a free gift.';
    var bar = '<div class="tsc-tier"><div class="tsc-tier__t">' + ICON.gift + '<span>' + esc(head) + '</span></div><div class="tsc-tier__bar"><span style="width:' + pct + '%"></span>' + marks + '</div></div>';
    if (!tier) return bar;
    var g = giftLine();
    var picks = tier.gifts.map(function (x) {
      var on = g && g.handle === x.handle;
      return '<button type="button" class="tsc-gift' + (on ? ' is-on' : '') + '" data-act="gift" data-h="' + esc(x.handle) + '" aria-pressed="' + !!on + '">' +
        (x.image ? '<img src="' + esc(x.image) + '" alt="" width="80" height="80" loading="lazy">' : '') +
        '<span class="tsc-gift__n">' + esc(x.title) + '</span><span class="tsc-gift__v">' + (on ? 'Selected' : moneyRound(Math.round(x.value * RATE)) + ' value') + '</span></button>';
    }).join('');
    var wait = g && g.line_price > 0 ? '<p class="tsc-muted tsc-small">Applying your free gift. It takes a moment and updates by itself.</p>' : '';
    return bar + '<div class="tsc-block"><div class="tsc-lbl">Your gift</div><div class="tsc-block__h">' + (tier.gifts.length > 1 ? 'Choose one, it is on us' : 'Included with your order') + '</div>' +
      '<div class="tsc-gifts">' + picks + '</div>' + wait + '<p class="tsc-muted tsc-small">If the piece is returned, the gift comes back with it.</p></div>';
  }
  function extrasHTML() {
    var a = (S.data && S.data.attributes) || {};
    var isGift = a['Gift'] === 'Yes';
    var codes = (S.data && S.data.discounts) || [];
    return '<div class="tsc-block tsc-extras">' +
      '<button type="button" class="tsc-row" data-act="giftnote" aria-expanded="' + isGift + '"><span>This is a gift</span><span class="tsc-switch' + (isGift ? ' is-on' : '') + '" aria-hidden="true"><span></span></span></button>' +
      (isGift ? '<div class="tsc-note"><label class="tsc-lbl" for="tsc-note-' + 'x' + '">Gift note</label>' +
        '<textarea id="tsc-note-x" rows="3" maxlength="240" data-act="note" placeholder="Write a short note. We print it on a card.">' + esc(a['Gift note'] || '') + '</textarea>' +
        '<label class="tsc-check"><input type="checkbox" data-act="hideprices"' + (a['Hide prices'] === 'Yes' ? ' checked' : '') + '> Hide prices on the packing slip</label></div>' : '') +
      '<button type="button" class="tsc-row" data-act="promo" aria-expanded="' + S.promoOpen + '"><span>Promo code</span><span aria-hidden="true">' + (S.promoOpen ? '−' : '+') + '</span></button>' +
      (S.promoOpen ? '<form class="tsc-promo" data-act="promoform"><label class="tsc-sr" for="tsc-promo-in">Promo code</label><input id="tsc-promo-in" name="code" autocomplete="off" placeholder="Enter code"><button type="submit" class="tsc-btn">Apply</button></form>' +
        (S.promoMsg ? '<p class="tsc-small tsc-err" role="alert">' + esc(S.promoMsg) + '</p>' : '') : '') +
      (codes.length ? '<div class="tsc-codes">' + codes.map(function (c) { return '<span class="tsc-code">' + esc(c.code) + ' <button type="button" data-act="unpromo" aria-label="Remove code ' + esc(c.code) + '">' + ICON.close + '</button></span>'; }).join('') + '</div>' : '') +
      '</div>';
  }
  function rowsHTML() {
    var list = pieces(); if (!list.length) return '';
    var data = S.data, sub = list.reduce(function (a, pc) { return a + pc.original; }, 0);
    var g = giftLine(), intl = data.intl;
    var shopTotal = Math.round(data.total / RATE);
    var ship = intl ? (shopTotal >= 200000 ? 'Free' : 'At checkout') : 'Free';
    var giftOff = g ? Math.max(0, g.original_line_price - g.line_price) : 0;
    var savings = Math.max(0, (data.discount_total || 0) - giftOff);
    var make = bagMake(list);
    var crane = CRANE ? '<img class="tsc-crane" src="' + esc(CRANE) + '" alt="" width="22" height="51">' : '';
    return '<div class="tsc-sum">' +
      '<div class="tsc-sum__r"><span>Subtotal</span><span>' + money(sub) + '</span></div>' +
      (savings > 0 ? '<div class="tsc-sum__r"><span>Savings</span><span>−' + money(savings) + '</span></div>' : '') +
      '<div class="tsc-sum__r"><span>' + (intl ? 'Insured shipping' : 'Insured shipping, signature on delivery') + '</span><span>' + ship + '</span></div>' +
      (g ? '<div class="tsc-sum__r"><span>Your gift</span><span>' + (g.line_price > 0 ? money(g.line_price) : 'Included') + '</span></div>' : '') +
      (shopTotal >= 200000 ? '<div class="tsc-sum__r"><span>Appraisal</span><span>Free</span></div>' : '') +
      '<div class="tsc-sum__r tsc-sum__r--tot"><span>Estimated total</span><span>' + money(data.total) + '</span></div>' +
      '<div class="tsc-small tsc-muted">Taxes calculated at checkout' + (intl ? '. Duties and taxes are paid by the recipient.' : '') + '</div>' +
      (make != null && make > 0 ? '<div class="tsc-manifest">' + crane + '<span>Across your bag, we make <b>' + moneyRound(Math.round(make * RATE)) + '</b>. The full breakdown comes printed in your Transparency Manifest.</span></div>' : '') +
      '</div>';
  }
  function actionsHTML(mode) {
    if (!pieces().length) return '';
    var blocked = Object.keys(S.sold).length > 0 || S.broken.length > 0 || Object.keys(S.heldElse).length > 0;
    return '<div class="tsc-acts">' +
      (S.error ? '<p class="tsc-err" role="alert">' + esc(S.error) + '</p>' : '') +
      (S.leaving ? '<p class="tsc-small tsc-center" role="status">' + esc(S.leaving) + '</p>' : '') +
      (blocked ? '<p class="tsc-small tsc-center">' + (Object.keys(S.sold).length || S.broken.length ? 'Choose a new diamond or remove the sold piece to check out.' : 'Choose a similar diamond or remove the reserved piece to check out.') + '</p>' : '') +
      '<button type="button" class="tsc-checkout" data-act="checkout"' + (blocked || S.busy || S.checking ? ' disabled' : '') + '><span>' + (S.checking ? 'Checking your bag…' : 'Secure checkout') + '</span><span>' + money(S.data.total) + '</span></button>' +
      (mode === 'drawer' ? '<a class="tsc-btn tsc-btn--full" href="' + ROOT + 'cart">View bag</a>' : '') +
      shareRowHTML() +
      '<div class="tsc-small tsc-muted tsc-center tsc-tag">' + ICON.lock + ' Clarity is a Form of Luxury.</div>' +
      '</div>';
  }
  function trustHTML() {
    var intl = S.data && S.data.intl;
    return '<ul class="tsc-trust">' +
      '<li>' + ICON.truck + '<span>' + (intl ? 'Insured shipping, free over $2,000' : 'Free insured US shipping') + '</span></li>' +
      '<li>' + ICON.ret + '<span>' + (intl ? '45-day returns' : '45-day returns, free both ways') + '</span></li>' +
      '<li>' + ICON.ring + '<span>One free resize within 60 days</span></li>' +
      '<li>' + ICON.shield + '<span>Lifetime promise</span></li></ul>';
  }
  function emptyHTML() {
    return '<div class="tsc-empty">' + (CRANE ? '<img src="' + esc(CRANE) + '" alt="" width="44" height="101">' : '') +
      '<p class="tsc-empty__t">Your bag is waiting</p><p class="tsc-muted">Every piece shows what it costs us and what we make. Start with the one you came for.</p>' +
      '<a class="tsc-checkout tsc-checkout--c" href="/pages/build-your-ring">Design your ring</a>' +
      '<a class="tsc-btn tsc-btn--full" href="/collections/all-jewelry">Shop jewelry</a></div>';
  }
  /* ---------- share the bag ----------
     A snapshot of the bag's lines (variant, quantity, line notes; never the free gift) is kept by the bag-share
     function under a short id. truesanity.com/cart?bag=<id> adds those pieces to the opener's own bag, at today's
     prices; the usual stock checks, diamond holds and gift rules then apply to them. */
  function shareRowHTML() {
    var m = S.share || {};
    var link = m.url && m.manual ? '<input class="tsc-share__in" type="text" readonly value="' + esc(m.url) + '" aria-label="Link to this bag" onfocus="this.select()">' : '';
    return '<div class="tsc-share">' +
      '<button type="button" class="tsc-share__b" data-act="share"' + (m.busy ? ' disabled' : '') + '>' + ICON.share + '<span>' + (m.busy ? 'Making your link…' : 'Share your bag') + '</span></button>' +
      (m.msg ? '<span class="tsc-small tsc-muted" role="status">' + esc(m.msg) + '</span>' : '') + link + '</div>';
  }
  function shareItems() {
    return ((S.data && S.data.items) || []).filter(function (it) { return !it.gift && !(it.properties && it.properties._free_gift); })
      .map(function (it) {
        var p = {};
        Object.keys(it.properties || {}).forEach(function (k) { var v = it.properties[k]; if (v != null && v !== '' && typeof v !== 'object') p[k] = String(v); });
        return { id: it.variant_id, quantity: it.quantity, properties: p };
      });
  }
  function shareBag() {
    var items = shareItems();
    if (!items.length || (S.share && S.share.busy)) return;
    S.share = { busy: true }; render();
    fetch(SHARE, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ op: 'save', items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || !j.id) throw new Error('save'); return j.id; }); })
      .then(function (id) {
        var url = location.origin + ROOT + 'cart?bag=' + id;
        // phones: the share sheet (Messages, WhatsApp, email); elsewhere: copy the link
        var touch = w.matchMedia && w.matchMedia('(pointer: coarse)').matches;
        if (touch && navigator.share) {
          return navigator.share({ title: 'My True Sanity bag', text: 'Here is my bag at True Sanity.', url: url })
            .then(function () { S.share = { msg: 'Shared.', url: url }; })
            .catch(function (e) { S.share = e && e.name === 'AbortError' ? { url: url } : { msg: 'Copy your link:', url: url, manual: true }; });
        }
        return (navigator.clipboard && navigator.clipboard.writeText ? navigator.clipboard.writeText(url) : Promise.reject())
          .then(function () { S.share = { msg: 'Link copied. Paste it anywhere to share.', url: url }; })
          .catch(function () { S.share = { msg: 'Copy your link:', url: url, manual: true }; });
      })
      .catch(function () { S.share = { msg: 'We could not make a link just now. Please try again.' }; })
      .then(function () { render(); var i = $('.tsc-share__in'); if (i) { i.focus(); i.select(); } });
  }
  // the opener's side: ?bag=<id> on any page
  function openShared() {
    var q = null; try { q = new URLSearchParams(location.search).get('bag'); } catch (e) {}
    if (!q || !/^[2-9A-HJKMNP-Za-hjkmnp-z]{7}$/.test(q)) return;
    try { var u = new URL(location.href); u.searchParams.delete('bag'); history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (e) {}
    fetch(SHARE, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ op: 'get', id: q }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        var items = res.ok && res.j && Array.isArray(res.j.items) ? res.j.items : null;
        if (!items || !items.length) { S.sharedMsg = 'That shared bag link has expired. Ask for a new one, or start your own below.'; render(); return show(); }
        if (!pieces().length) return addShared(items, false);
        S.shared = { items: items, n: items.reduce(function (a, x) { return a + (x.properties && (x.properties._earring_part === 'diamond1' || x.properties._earring_part === 'diamond2') ? 0 : x.quantity); }, 0) };
        render(); show();
      })
      .catch(function () { S.sharedMsg = 'We could not open that shared bag just now. Please try the link again.'; render(); show(); });
    function show() { if (drawer && !onCartPage()) openDrawer(true); }
  }
  function addShared(items, replace) {
    var before = {}, missed = 0;
    if (!replace) ((S.data && S.data.items) || []).forEach(function (x) { before[x.key] = x.quantity; });
    S.shared = null;
    return mutate(function () {
      var start = replace ? (releaseStones(pieces()), post('clear', {})) : Promise.resolve();
      return start.then(function () {
        // all at once; if Shopify turns the batch down (one piece sold out), add them one by one and count the misses
        return post('add', { items: items }).catch(function () {
          return items.reduce(function (p, x) { return p.then(function () { return post('add', { items: [x] }).catch(function () { missed++; }); }); }, Promise.resolve());
        });
      }).then(function () {
        S.sharedMsg = missed ? (missed === items.length ? 'The pieces in that shared bag are no longer available.' : missed + (missed === 1 ? ' piece' : ' pieces') + ' from the shared bag ' + (missed === 1 ? 'is' : 'are') + ' no longer available.') : 'Here is the bag that was shared with you.';
      });
    }).then(function () {
      if (drawer && !onCartPage()) openDrawer(true);
      trackAdded(before);
    });
  }
  function sharedHTML() {
    if (S.shared) {
      return '<div class="tsc-alert" role="status"><div class="tsc-alert__t">A bag was shared with you</div>' +
        '<p>' + S.shared.n + (S.shared.n === 1 ? ' piece' : ' pieces') + ', at today\'s prices. Your bag already has pieces in it.</p>' +
        '<div class="tsc-alert__b"><button type="button" class="tsc-btn" data-act="shared-add">Add to my bag</button>' +
        '<button type="button" class="tsc-btn" data-act="shared-replace">Replace my bag</button>' +
        '<button type="button" class="tsc-link" data-act="shared-no">Not now</button></div></div>';
    }
    return S.sharedMsg ? '<div class="tsc-alert" role="status"><p>' + esc(S.sharedMsg) + '</p></div>' : '';
  }
  var CRANE = '';
  function render() {
    if (!S.data) return;
    var list = pieces(), n = visibleCount();
    $$('[data-tsc-view]').forEach(function (root) {
      var mode = root.getAttribute('data-tsc-view');
      var body = $('[data-tsc-body]', root), foot = $('[data-tsc-foot]', root), count = $('[data-tsc-count]', root);
      root.classList.toggle('is-busy', S.busy);
      root.setAttribute('aria-busy', String(S.busy));
      if (count) count.textContent = n ? n + (n === 1 ? ' piece' : ' pieces') : '';
      if (!list.length) { body.innerHTML = sharedHTML() + emptyHTML(); if (foot) foot.innerHTML = ''; root.classList.add('is-empty'); return; }
      root.classList.remove('is-empty');
      var focusId = d.activeElement && root.contains(d.activeElement) ? d.activeElement.id : null;
      var brokenHTML = S.broken.map(function (keys) {
        return '<div class="tsc-alert" role="status"><div class="tsc-alert__t">Your earrings need the setting and both diamonds together</div><p>One part of this pair was removed or its quantity changed. Remove the earrings and build them again.</p>' +
          '<div class="tsc-alert__b"><button type="button" class="tsc-btn" data-act="remove" data-keys="' + esc(keys.join('|')) + '">Remove the earrings</button></div></div>';
      }).join('');
      var items = '<div class="tsc-items">' + list.map(function (pc) { return pieceHTML(pc, mode); }).join('') + '</div>';
      if (mode === 'drawer') {
        body.innerHTML = sharedHTML() + giftHTML() + brokenHTML + items + extrasHTML() + '<div class="tsc-block tsc-block--sum">' + rowsHTML() + trustHTML() + '</div>';
        foot.innerHTML = actionsHTML(mode);
      } else {
        body.innerHTML = sharedHTML() + brokenHTML + items + giftHTML();
        foot.innerHTML = rowsHTML() + actionsHTML(mode) + extrasHTML() + trustHTML();
      }
      if (focusId) { var f = d.getElementById(focusId); if (f) f.focus(); }
    });
    $$('.tsx__count, .cart-count-bubble').forEach(function (b) {
      var s = b.querySelector('span[aria-hidden]') || b;
      if (s.textContent !== String(n)) s.textContent = String(n);
      if (n > 0) b.removeAttribute('data-empty'); else b.setAttribute('data-empty', '');
    });
  }

  /* ---------- actions ---------- */
  function pieceBy(key) { return pieces().filter(function (pc) { return pc.key === key; })[0]; }
  function onClick(e) {
    var b = e.target.closest('[data-act]'); if (!b || b.tagName === 'SELECT' || b.tagName === 'TEXTAREA' || b.tagName === 'FORM') return;
    var act = b.getAttribute('data-act'), key = b.getAttribute('data-key'), pc = key ? pieceBy(key) : null;
    if (act === 'checkout') { e.preventDefault(); return checkout(); }
    if (act === 'share') return shareBag();
    if (act === 'shared-add' && S.shared) return addShared(S.shared.items, false);
    if (act === 'shared-replace' && S.shared) return addShared(S.shared.items, true);
    if (act === 'shared-no') { S.shared = null; return render(); }
    if (act === 'make') { S.openMake[key] = !S.openMake[key]; return render(); }
    if (act === 'ackprice') return ackPrice(key);
    if (act === 'promo') { S.promoOpen = !S.promoOpen; S.promoMsg = ''; render(); var inp = $('#tsc-promo-in'); if (inp) inp.focus(); return; }
    if (act === 'swapd' && pc) return swapDiamond(pc);
    if (act === 'remove') { var keys = b.getAttribute('data-keys').split('|'); releaseStones(pieces().filter(function (x) { return keys.indexOf(x.key) > -1; })); return mutate(function () { return removeKeys(keys); }); }
    if (act === 'qty') { var q = parseInt(b.getAttribute('data-q'), 10); if (q < 1) return; return mutate(function () { return setQty(pc.main, q); }); }
    if (act === 'save' && pc) return saveForLater(pc);
    if (act === 'gift') { var h = b.getAttribute('data-h'); if (b.classList.contains('is-on')) return; return mutate(function () {}, { gift: h }); }
    if (act === 'quality' && pc) {
      var t = (pc.main.quality.tiers || []).filter(function (x) { return x.handle === b.getAttribute('data-h'); })[0];
      var curO = curOpts(pc.main);
      var sv = t && siblingVariant(t, curO); if (!sv) return;
      return mutate(function () { return swapVariant(pc, sv, { _selectedImage: imgFor(t.image, pc) }); });
    }
    if (act === 'upsize' && pc) {
      var bv = pc.main.variants.filter(function (x) { return String(x.id) === b.getAttribute('data-v'); })[0];
      if (bv) return mutate(function () { return swapVariant(pc, bv); });
      return;
    }
    if (act === 'upsize-sib' && pc) {
      var zz = sizesOf(pc.main).filter(function (z) { return z.handle === b.getAttribute('data-h'); })[0];
      if (zz && zz.sv) return mutate(function () { return swapVariant(pc, zz.sv, { _selectedImage: imgFor(zz.image, pc) }); });
      return;
    }
    if (act === 'giftnote') {
      var on = !((S.data.attributes || {})['Gift'] === 'Yes');
      return mutate(function () { return post('update', { attributes: { 'Gift': on ? 'Yes' : '', 'Hide prices': on ? 'Yes' : '', 'Gift note': on ? ((S.data.attributes || {})['Gift note'] || '') : '' } }); });
    }
    if (act === 'unpromo') return mutate(function () { return post('update', { discount: '' }); });
    if (act === 'close') return openDrawer(false);
  }
  function onChange(e) {
    var el = e.target, act = el.getAttribute && el.getAttribute('data-act'); if (!act) return;
    var key = el.getAttribute('data-key'), pc = key ? pieceBy(key) : null;
    if (act === 'opt' && pc) {
      var i = +el.getAttribute('data-i'), val = el.value, it = pc.main;
      var curO = curOpts(it);
      var want = curO.slice(); want[i] = val;
      var v = it.variants.filter(function (x) { return x.o.every(function (o, j) { return o === want[j]; }); })[0] ||
        it.variants.filter(function (x) { return x.a && x.o[i] === val; })[0] || it.variants.filter(function (x) { return x.o[i] === val; })[0];
      if (!v || String(v.id) === String(it.variant_id)) return;
      return mutate(function () { return swapVariant(pc, v); });
    }
    if (act === 'dyometal' && pc) return dyoMetal(pc, el.value);
    if ((act === 'qsel' || act === 'ssel') && pc) {
      var h = el.value, src = act === 'qsel' ? (pc.main.quality.tiers || []) : sizesOf(pc.main);
      var tt = src.filter(function (x) { return x.handle === h; })[0];
      if (!tt || tt.current) return;
      var sv2 = act === 'qsel' ? siblingVariant(tt, curOpts(pc.main)) : tt.sv;
      if (!sv2) return;
      return mutate(function () { return swapVariant(pc, sv2, { _selectedImage: imgFor(tt.image, pc) }); });
    }
    if (act === 'size' && pc) {
      var props = cleanProps(pc.main.properties, { Size: el.value });
      props._selectedImage = (pc.main.properties || {})._selectedImage;
      if (!props._selectedImage) delete props._selectedImage;
      return mutate(function () { return setQty(pc.main, pc.main.quantity, props); });
    }
    if (act === 'note') return mutate(function () { return post('update', { attributes: { 'Gift note': el.value.slice(0, 240) } }); });
    if (act === 'hideprices') return mutate(function () { return post('update', { attributes: { 'Hide prices': el.checked ? 'Yes' : '' } }); });
  }
  function onSubmit(e) {
    var f = e.target; if (f.getAttribute('data-act') !== 'promoform') return;
    e.preventDefault();
    var code = (f.code.value || '').trim(); if (!code) return;
    S.promoMsg = '';
    mutate(function () {
      return post('update', { discount: code }).then(function (c) {
        var hit = (c.discount_codes || []).filter(function (x) { return String(x.code).toLowerCase() === code.toLowerCase(); })[0];
        if (!hit || !hit.applicable) { S.promoMsg = 'That code does not apply to this bag.'; if (hit) return post('update', { discount: (c.discount_codes || []).filter(function (x) { return x.applicable; }).map(function (x) { return x.code; }).join(',') }); }
        else S.promoOpen = false;
      });
    });
  }
  function saveForLater(pc) {
    var it = pc.main;
    if (w.TSW && w.TSW.add) {
      try {
        w.TSW.add({ key: 'p:' + it.product_id, kind: 'product', pid: String(it.product_id), vid: String(it.variant_id), handle: it.handle,
          url: pc.w ? '' : it.url, title: titleOf(pc), image: photoOf(it), price: it.variant_price });
      } catch (e) {}
    }
    return mutate(function () { return removeKeys(pc.keys); });
  }
  function checkout() {
    if (S.busy || S.checking) return;
    S.checking = true; render();
    refresh().then(function () { FORCE = true; return checkStones(); }).then(function (ok) {
      FORCE = false;
      if (ok) { location.href = ROOT + 'checkout'; return; }
      S.checking = false; render();
      var a = $('.tsc-alert'); if (a) a.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }).catch(function () { FORCE = false; location.href = ROOT + 'checkout'; });
  }

  /* ---------- the drawer ---------- */
  var drawer = null, lastFocus = null, hoverArmed = true;
  function openDrawer(on) {
    if (!drawer) return;
    if (on) {
      lastFocus = d.activeElement;
      drawer.hidden = false;
      setTimeout(function () { drawer.classList.add('is-open'); var c = $('[data-act="close"]', drawer); if (c) c.focus(); }, 20);
      d.documentElement.classList.add('tsc-lock');
      if (S.data) checkStones().then(render);
    } else {
      // the close button sits over the header bag: don't let a resting mouse reopen the drawer
      hoverArmed = false;
      d.addEventListener('mousemove', function rearm(ev) {
        var over = ev.target.closest && ev.target.closest('#cart-icon-bubble, a.header__icon--cart, [data-tsc-open], .tsc-drawer');
        if (!over) { hoverArmed = true; d.removeEventListener('mousemove', rearm); }
      });
      drawer.classList.remove('is-open');
      d.documentElement.classList.remove('tsc-lock');
      setTimeout(function () { drawer.hidden = true; }, 260);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
  }
  function trapTab(e) {
    if (!drawer || drawer.hidden) return;
    if (e.key === 'Escape') return openDrawer(false);
    if (e.key !== 'Tab') return;
    var f = $$('a[href],button:not([disabled]),select,textarea,input', drawer).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }

  /* ---------- other scripts that add to the bag: open the drawer with the new piece ---------- */
  function watchAdds() {
    var of = w.fetch;
    if (of && !of.__tsc) {
      var nf = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = of.apply(this, arguments);
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && !(init && init.__tsc) && !quiet) {
          p.then(function (r) { if (r && r.ok) setTimeout(afterAdd, 50); }).catch(function () {});
        }
        return p;
      };
      nf.__tsc = true; w.fetch = nf;
    }
    var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__tscAdd = /\/cart\/add(\.js)?(\?|$)/.test(String(u || '')); return xo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (this.__tscAdd && !quiet) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) afterAdd(); });
      return xs.apply(this, arguments);
    };
  }
  // after another script adds a piece: make sure the gift line is right, then show the bag
  function afterAdd() {
    var before = {};
    ((S.data && S.data.items) || []).forEach(function (x) { before[x.key] = x.quantity; });
    return giftFix().then(refresh).then(function () {
      if (!onCartPage()) openDrawer(true);
      trackAdded(before);
    });
  }
  // Klaviyo "Added to Cart" (starts the abandoned-cart flow). Only for shopper adds, never the free gift,
  // in-bag edits or upgrades. Klaviyo records it only for shoppers it already knows (popup, email click, checkout).
  // before: line quantities before the add; or only: {lineKey: quantityAdded} for adds made on another page
  function trackAdded(before, only) {
    var k = w.klaviyo || w._learnq;
    if (!k || !k.push) return;
    json(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (c) {
      var items = (c && c.items) || [];
      var real = items.filter(function (i) { return !(i.properties && i.properties._free_gift); });
      var origin = location.origin;
      var mapped = real.map(function (i) {
        return {
          ProductID: i.product_id, VariantID: i.variant_id, SKU: i.sku, ProductName: i.product_title,
          VariantName: i.variant_title || '', Quantity: i.quantity, ItemPrice: i.final_price / 100,
          RowTotal: i.final_line_price / 100, ProductURL: origin + i.url, ImageURL: i.image || '',
          ProductCategories: i.product_type ? [i.product_type] : []
        };
      });
      real.forEach(function (i, n) {
        var addQ;
        if (only) { if (!only[i.key]) return; addQ = only[i.key]; }
        else { if (i.quantity <= (before[i.key] || 0)) return; addQ = i.quantity - (before[i.key] || 0); }
        var m = mapped[n];
        try {
          k.push(['track', 'Added to Cart', {
            $value: c.total_price / 100,
            AddedItemProductName: m.ProductName, AddedItemProductID: m.ProductID, AddedItemSKU: m.SKU,
            AddedItemVariantName: m.VariantName, AddedItemCategories: m.ProductCategories,
            AddedItemImageURL: m.ImageURL, AddedItemURL: m.ProductURL, AddedItemPrice: m.ItemPrice,
            AddedItemQuantity: addQ,
            ItemNames: mapped.map(function (x) { return x.ProductName; }),
            CheckoutURL: origin + ROOT + 'cart', Items: mapped
          }]);
        } catch (e) {}
      });
    }).catch(function () {});
  }
  // Shopify re-checks automatic discounts only when a bag changes, so bags filled before a discount change keep the
  // old prices. Once per bag (per REPRICE version), re-save the first line at its own quantity so Shopify re-prices it.
  var REPRICE = '2026-10-23';
  function repriceOnce() {
    return json(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (c) {
      var it = c && c.items && c.items[0];
      if (!it || (c.attributes && c.attributes._ts_reprice === REPRICE)) return;
      var post = function (path, body) {
        return fetch(ROOT + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      };
      return post('cart/change.js', { id: it.key, quantity: it.quantity })
        .then(function () { return post('cart/update.js', { attributes: { _ts_reprice: REPRICE } }); });
    }).catch(function () {});
  }
  function onCartPage() { return !!$('[data-tsc-view="page"]'); }
  // a product page added a piece and then came to the bag page: send its "Added to Cart" here, once Klaviyo is loaded
  function trackPending() {
    var only;
    try { only = JSON.parse(sessionStorage.getItem('ts_kl_added') || 'null'); sessionStorage.removeItem('ts_kl_added'); } catch (e) { return; }
    if (!only) return;
    var tries = 0;
    (function go() {
      var k = w.klaviyo || w._learnq;
      if (k && k.push) return trackAdded(null, only);
      if (++tries < 20) setTimeout(go, 250);
    })();
  }

  function init() {
    var first = $('[data-ts-cart-json]');
    drawer = $('[data-tsc-view="drawer"]');
    // the header slides (transform), which would trap a fixed drawer inside it: the drawer lives on <body>
    if (drawer && drawer.parentNode !== d.body) d.body.appendChild(drawer);
    CRANE = d.documentElement.getAttribute('data-tsc-crane') || (drawer && drawer.getAttribute('data-crane')) || ($('[data-tsc-view="page"]') || { getAttribute: function () { return ''; } }).getAttribute('data-crane') || '';
    $$('[data-tsc-view]').forEach(function (r) {
      r.addEventListener('click', onClick);
      r.addEventListener('change', onChange);
      r.addEventListener('submit', onSubmit);
    });
    if (drawer) {
      d.addEventListener('keydown', trapTab);
      $$('[data-tsc-overlay]', drawer).forEach(function (o) { o.addEventListener('click', function () { openDrawer(false); }); });
      // the header bag opens the drawer (the bag page link still works without JavaScript).
      // Capture phase + stop: the old cart script (custom-jtpl.js) sends this click to /cart.
      var BAG = '#cart-icon-bubble, a.header__icon--cart, [data-tsc-open]';
      d.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest(BAG);
        if (!a || onCartPage()) return;
        e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        openDrawer(true);
      }, true);
      // desktop: resting the mouse on the bag opens it too
      if (w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        var hoverT = null;
        d.addEventListener('mouseover', function (e) {
          var a = e.target.closest && e.target.closest(BAG);
          if (!a || onCartPage() || !drawer.hidden || !hoverArmed) return;
          clearTimeout(hoverT);
          hoverT = setTimeout(function () { openDrawer(true); }, 180);
          a.addEventListener('mouseleave', function () { clearTimeout(hoverT); }, { once: true });
        });
      }
    }
    // first paint from the inline data, then the full data (with line notes) right after
    if (first) { try { var d0 = JSON.parse(first.textContent); S.data = d0; trackPrices(); render(); } catch (e) {} }
    repriceOnce().then(refresh).catch(function () {}).then(trackPending).then(openShared);
    watchAdds();
    // leaving the page (View bag, Checkout, a product link) with the drawer open: close it right away, so a page
    // restored from the back/forward cache never comes back frozen behind the backdrop with scrolling locked
    function shut() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.hidden = true; d.documentElement.classList.remove('tsc-lock'); S.checking = false; S.busy = false; }
    w.addEventListener('pagehide', shut);
    w.addEventListener('pageshow', function (e) { if (e.persisted) { shut(); refresh(); } });
    if (drawer) drawer.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (a && !e.defaultPrevented && !a.target) {
        d.documentElement.classList.remove('tsc-lock');
        if (/\/cart\/?$/.test(a.getAttribute('href') || '')) { a.textContent = 'Opening your bag…'; a.setAttribute('aria-busy', 'true'); }
      }
    });
  }

  // older theme scripts (custom-jtpl.js) call Shopify.formatMoney after cart requests; the old drawer used to
  // bring it in. Keep it defined so those scripts don't throw.
  if (w.Shopify && typeof w.Shopify.formatMoney !== 'function') {
    w.Shopify.formatMoney = function (cents) { return money(typeof cents === 'string' ? parseInt(cents.replace(/[^0-9]/g, ''), 10) : cents); };
  }

  w.TSCart = { refresh: refresh, open: function () { openDrawer(true); }, close: function () { openDrawer(false); }, check: checkStones, state: S };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
